/* eslint-disable */
import { CircularProgress, Grid, Box } from "@material-ui/core";
import { find, sortBy } from "lodash";
import moment from "moment";
import React, { useEffect, useState, useMemo } from "react";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";

import ScheduleList from "../../components/ScheduleList";
import CustomSwitch from "../../components/Switch";
import Constants from "../../utils/constants";
import { validateCourtId } from "../../utils/data";
import "./styles.scss";
import { getRouteSchedule } from "../../utils/api";
import { langStringConvertor } from "../../utils/utils";

const { LANGUAGES } = Constants;
const { scheduleTitle, weekdays, notOperateToday, notOperateThatDay } =
  LANGUAGES;

const Schedule = (props) => {
  const { routes, lang, setCurrentTitle, court, isTodayHoliday, isRA, themeColour } = props;
  // const { routeId, routeSeq } = props.match.params;
  const [courtSchedules, setCourtSchedules] = useState(null);
  const [schedulesToShow, setSchedulesToShow] = useState([]);
  const [language, setLanguage] = useState(null);
  const [origins, setOrigins] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [typeOfSchedules, setTypeOfSchedules] = useState(null);
  // console.log("lang, courtSchedules", lang, courtSchedules);
  const todayWeekday = useMemo(() => isTodayHoliday ? 8 : moment().isoWeekday(), [isTodayHoliday]);
  const [weekday, setWeekday] = useState(isTodayHoliday ? 8 : moment().isoWeekday());

  useEffect(() => {
    console.log("todayWeekday", todayWeekday);
  }, [todayWeekday]);

  useEffect(() => {
    console.log("weekday", weekday);
  }, [weekday]);

  const getCourtSchedules = async () => {
    console.log("getCourtSchedules");
    await Promise.all(
      routes.map(async (route) => {
        const tempSchedule = await getRouteSchedule(route.route_id, weekday);
        return route.directions.map((direction) => {
          return {
            ...direction,
            schedule: tempSchedule.find(
              (el) => parseInt(el.route_seq, 10) === direction.route_seq
            ),
            description_en: route.description_en,
            description_sc: route.description_sc,
            description_tc: route.description_tc,
          };
        });
      })
    ).then((result) => {
      setCourtSchedules(result);
    });
  };

  const renderSchedules = () => {
    return courtSchedules.map((courtSchedule) =>
      courtSchedule.map((directions) => {
        // console.log(directions);
        const onlyOneRoute =
          courtSchedule.length === 1 && courtSchedule.length === 1;
        const description = directions[`description_tc`].match(/正常/)
          ? null
          : directions[`description_${langStringConvertor(lang)}`];
        const haveSchedule = directions?.schedule;
        return (
          <React.Fragment
            key={`${directions["orig_en"]}${directions["dest_en"]}`}
          >
            <Grid item xs={onlyOneRoute ? 12 : 6} className="schedule-list">
              <div
                className={`header ${court} ${language} `}
                style={{
                  backgroundColor: directions?.eta_app_color || themeColour,
                }}
              >
                <div className="schedule-title">
                  <span style={{ fontWeight: 700, marginRight: "10px" }}>
                    {lang === "zh" || lang === "cn" ? "由" : "From"}
                  </span>
                  <span>{directions[`orig_${langStringConvertor(lang)}`]}</span>
                </div>
                <div className="schedule-title">
                  <span style={{ fontWeight: 700, marginRight: "10px" }}>
                    {" "}
                    {lang === "zh" || lang === "cn" ? "往" : "To"}
                  </span>
                  <span>{directions[`dest_${langStringConvertor(lang)}`]}</span>
                  {description && (
                    <span style={{ marginLeft: "10px" }}>({description})</span>
                  )}
                </div>
              </div>
              {directions?.schedule?.schedules ? (
                <div className="content">
                  <Grid container spacing={1}>
                    {directions?.schedule?.schedules.map((time, index) => {
                      let ra2dollar = false;
                      {
                        /**
                         * This is For Royal Ascor Only
                         */
                      }
                      if (isRA) {
                        if (directions.route_seq === 1) {
                          if (
                            moment(time).diff(
                              moment().startOf("day").add(869, "minutes")
                            ) > 0
                          ) {
                            ra2dollar = true;
                          }
                        } else {
                          if (
                            moment(time).diff(
                              moment().startOf("day").add(691, "minutes")
                            ) < 0
                          ) {
                            ra2dollar = true;
                          }
                        }
                      }
                      {
                        /**
                         * This is For Royal Ascor Only -- END
                         */
                      }
                      const now = moment();
                      if (todayWeekday !== weekday || now.diff(time) < 0) {
                        return (
                          <Grid
                            item
                            xs={onlyOneRoute ? 3 : 4}
                            key={`${time}_${index}`}
                          >
                            <div
                              className={`schedule-cell ${court} pending ${
                                ra2dollar && `ra2dollar`
                              }`}
                              style={{ border: `1px solid ${themeColour}` }}
                            >
                              {moment(time).format("HH:mm")}
                            </div>
                          </Grid>
                        );
                      } else {
                        return (
                          <Grid
                            item
                            xs={onlyOneRoute ? 3 : 4}
                            key={`${time}_${index}`}
                          >
                            <div
                              className={`schedule-cell ${court} done ${
                                ra2dollar && `ra2dollar`
                              }`}
                            >
                              {moment(time).format("HH:mm")}
                            </div>
                          </Grid>
                        );
                      }
                    })}
                  </Grid>
                </div>
              ) : (
                <div className="content">
                  <Grid container>
                    <Grid item xs={12}>
                      <div className={`schedule-cell done`}>
                        {todayWeekday === weekday
                          ? notOperateToday[lang]
                          : notOperateThatDay[lang]}
                      </div>
                    </Grid>
                  </Grid>
                </div>
              )}
            </Grid>
          </React.Fragment>
        );
      })
    );
  };

  const handleWeekday = (event, newWeekday) => {
    console.log(newWeekday);
    if (newWeekday) {
      setWeekday(newWeekday);
    }
  };

  useEffect(() => {
    setWeekday(todayWeekday);
  }, [isTodayHoliday]);

  useEffect(() => {
    if (weekday && courtSchedules) {
      getCourtSchedules();
    }
  }, [weekday]);

  useEffect(() => {
    if (courtSchedules === null && routes && routes.length > 0) {
      getCourtSchedules();
    }
  }, [courtSchedules, routes]);

  useEffect(() => {
    setCurrentTitle(null);

    if (lang && courtSchedules) {
      setIsLoading(false);
    }
  }, [lang, courtSchedules]);

  return (
    <div className="schedule-container">
      {isLoading ? (
        <div
          style={{
            height: "100%",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
          className="progress-container"
        >
          <CircularProgress color={court === "rmb" ? "secondary" : "primary"} />
        </div>
      ) : (
        <>
          <Grid
            container
            justifyContent="center"
            style={{ height: "100%", overflowY: "scroll", overflowX: "hidden" }}
          >
            {/**
             * This is For Royal Ascor Only
             */}
            {isRA && (
              <Grid item xs={12} style={{ marginBottom: "10px" }}>
                <div style={{ display: "flex" }}>
                  <div
                    style={{
                      backgroundColor: "#3399ff",
                      color: "white",
                      borderRadius: "5px",
                      padding: "2.5px",
                      fontSize: "12px",
                      height: "20px",
                      textAlign: "center",
                      fontWeight: "700",
                      marginRight: "8px",
                    }}
                  >
                    00:00
                  </div>
                  <div>藍色班次 : 有長者$2乘車優惠</div>
                </div>
              </Grid>
            )}
            {/**
             * This is For Royal Ascor Only -- END
             */}
            <Grid container spacing={2}>
              {renderSchedules()}
            </Grid>
          </Grid>

          <Box
            xs={12}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: "fixed",
              bottom: "54px",
              left: 0,
              textAlign: "center",
              zIndex: "199",
              backgroundColor: "white",
              width: "100%",
              height: "55px",
              padding: 0,
              margin: 0,
              boxShadow: "0 2px 10px #000000",
            }}
          >
            <ToggleButtonGroup
              value={weekday}
              exclusive
              onChange={handleWeekday}
              aria-label="text alignment"
              style={{
                height: "100%",
                width: "100%",
                textAlign: "center",
                justifyContent: "space-between",
                paddingBottom: 2,
              }}
            >
              <ToggleButton
                value={1}
                aria-label="mon"
                style={{
                  fontSize: 12,
                  padding: 4,
                  width: "100%",
                  ...(todayWeekday === 1 && { color: "orangered" }),
                }}
              >
                {weekdays[1][lang]}
              </ToggleButton>
              <ToggleButton
                value={2}
                aria-label="tue"
                style={{
                  fontSize: 12,
                  padding: 4,
                  width: "100%",
                  ...(todayWeekday === 2 && { color: "orangered" }),
                }}
              >
                {weekdays[2][lang]}
              </ToggleButton>
              <ToggleButton
                value={3}
                aria-label="wed"
                style={{
                  fontSize: 12,
                  padding: 4,
                  width: "100%",
                  ...(todayWeekday === 3 && { color: "orangered" }),
                }}
              >
                {weekdays[3][lang]}
              </ToggleButton>
              <ToggleButton
                value={4}
                aria-label="thur"
                style={{
                  fontSize: 12,
                  padding: 4,
                  width: "100%",
                  ...(todayWeekday === 4 && { color: "orangered" }),
                }}
              >
                {weekdays[4][lang]}
              </ToggleButton>
              <ToggleButton
                value={5}
                aria-label="fri"
                style={{
                  fontSize: 12,
                  padding: 4,
                  width: "100%",
                  ...(todayWeekday === 5 && { color: "orangered" }),
                }}
              >
                {weekdays[5][lang]}
              </ToggleButton>
              <ToggleButton
                value={6}
                aria-label="sat"
                style={{
                  fontSize: 12,
                  padding: 4,
                  width: "100%",
                  ...(todayWeekday === 6 && { color: "orangered" }),
                }}
              >
                {weekdays[6][lang]}
              </ToggleButton>
              <ToggleButton
                value={7}
                aria-label="sun"
                style={{
                  fontSize: 12,
                  padding: 4,
                  width: "100%",
                  ...(todayWeekday === 7 && { color: "orangered" }),
                }}
              >
                {weekdays[7][lang]}
              </ToggleButton>
              <ToggleButton
                value={8}
                aria-label="ph"
                style={{
                  fontSize: 12,
                  padding: 4,
                  width: "100%",
                  ...(todayWeekday === 8 && { color: "orangered" }),
                }}
              >
                {weekdays[8][lang]}
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>
        </>
      )}
    </div>
  );
};

export default Schedule;
